import { TASK_TYPES } from "components/Dashboard/DoctorDashboard/attachments/constants";
import { useMemberDrive } from "contexts/orchid-drive";
import { useEffect } from "react";
import type { UploadTaskStatusStorageDriveProps } from "../..";
import TaskStatus from "../../../task-status";

const UploadTaskStatusMemberDrive = ({
  tasks,
  setAbortFn,
  onHide,
  onRemoveUpload,
}: UploadTaskStatusStorageDriveProps) => {
  const { uploadTaskAbort } = useMemberDrive({
    memberDrive: [],
  });

  useEffect(() => setAbortFn(uploadTaskAbort), [setAbortFn, uploadTaskAbort]);

  return !tasks.length ? null : (
    <TaskStatus
      variant={TASK_TYPES.upload}
      tasks={tasks}
      // TODO: go with the UX for now, show if has task
      show={true}
      onHide={onHide}
      onCancel={onRemoveUpload}
    />
  );
};

export default UploadTaskStatusMemberDrive;
